import { useNavigate, useParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { useAuthStore } from '@/lib/auth/store';
import { useAgentGroupDetail, useUpdateAgentGroup } from '../api';
import { AgentGroupForm } from './AgentGroupForm';

export function UpdateGroupAgentPage() {
  const navigate = useNavigate();
  const userId = useAuthStore((s) => s.userId);
  const { groupId } = useParams<{ groupId: string }>();
  const id = Number(groupId);

  const detail = useAgentGroupDetail(id);
  const update = useUpdateAgentGroup();

  if (detail.isLoading || !detail.data) {
    return (
      <div className="flex h-full items-center justify-center gap-2 text-muted-foreground">
        <Loader2 className="h-5 w-5 animate-spin" />
        Loading agent group…
      </div>
    );
  }

  return (
    <AgentGroupForm
      mode="update"
      initialGroupName={detail.data.groupName ?? ''}
      initialAgents={detail.data.agents ?? []}
      isPending={update.isPending}
      onSubmit={({ groupName, agents }) => {
        update.mutate(
          { userId: Number(userId), groupId: id, groupName, agents },
          {
            onSuccess: (res) => {
              if (res?.message === 'Parameters Incorrect') {
                toast.error(res.message);
                return;
              }
              toast.success(res?.message ?? 'Agent group updated');
              navigate('/group-agent-list');
            },
            onError: () => toast.error('Could not update the agent group.'),
          },
        );
      }}
    />
  );
}
